import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../guards/service/auth.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
const DBG = true;
const isPublic = (url: string) =>
  /\/api\/(registration|login|send-otp|reset-password)$/i.test(url) ||
  /\/api\/user$/i.test(url) ||
  /\/api\/careers/i.test(url) ||
  /\/api\/communities\/[^\/]+$/i.test(url);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = auth.getJwtToken?.();

  // if (DBG) {
  //   console.groupCollapsed('[AUTH-INT] outgoing', req.method, req.url);
  //   console.log('isPublic?', isPublic(req.url));
  //   console.log('hasToken?', !!token);
  //   console.groupEnd();
  // }

  const withAuth = token && !isPublic(req.url)
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(withAuth).pipe(
    catchError((err: any) => {
      // if (DBG) {
      //   console.group('[AUTH-INT] error', req.method, req.url);
      //   console.log('status', err?.status, err);
      //   console.groupEnd();
      // }
      if (err instanceof HttpErrorResponse && err.status === 401 && !isPublic(req.url)) {
        queueMicrotask(() => auth.handleLogout?.());
      }
      return throwError(() => err);
    })
  );
};
